import { render, staticRenderFns } from "./ListTreeOptionLabel.vue?vue&type=template&id=07b43ba0&scoped=true"
import script from "./ListTreeOptionLabel.vue?vue&type=script&lang=js"
export * from "./ListTreeOptionLabel.vue?vue&type=script&lang=js"
import style0 from "./ListTreeOptionLabel.vue?vue&type=style&index=0&id=07b43ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b43ba0",
  null
  
)

export default component.exports